<template>
  <div class="interface">
    <!-- 导航栏 -->
    <!-- <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div> -->
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <div>
          <!-- 图片部分 -->
          <div class="image_part" v-if="!imageGeneration">
            <div class="image_collection">
              <!-- <div class="collection">☆收藏</div> -->
              <div></div>
              <div class="favorites" @click="favorites()">收藏夹>>></div>
            </div>
            <div class="image_background" v-if="!imageUpload">
              {{ text.prompt }}
            </div>
            <div class="image_background_upload" v-if="imageUpload">
              <img class="image_upload" :src="imageUploadURL" />
            </div>
          </div>
          <div class="image_part" v-if="imageGeneration">
            <div class="image_collection">
              <div
                :class="['collection', { collected: isCollected }]"
                @click="showCollectible()"
              >
                {{ isCollected ? "★已收藏" : "☆收藏" }}
              </div>
              <div class="favorites" @click="favorites()">收藏夹>>></div>
            </div>
            <div class="image_display" v-if="!imageQuantity">
              <div class="image_display_prompt">选择图片进行编辑</div>
              <div class="image_display01">
                <img
                  @click="nextStep(0)"
                  class="image_ontology"
                  :src="imageList[0].xthumbPath"
                  alt=""
                />
                <img
                  @click="nextStep(1)"
                  class="image_ontology"
                  :src="imageList[1].xthumbPath"
                  alt=""
                />
              </div>
              <div class="image_display01">
                <img
                  @click="nextStep(2)"
                  class="image_ontology"
                  :src="imageList[2].xthumbPath"
                  alt=""
                />
                <img
                  @click="nextStep(3)"
                  class="image_ontology"
                  :src="imageList[3].xthumbPath"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 上传图片 -->
          <div class="upload" @click="selectCardface()">
            <div class="upload_name">上传图片>>></div>
            <img class="upload_button" :src="logUrlList.image_upload" alt="" />
          </div>
          <!-- 文字描述 -->
          <div>
            <textarea
              v-model="image_text_to_image.prompt"
              placeholder="请描述您的图片要素"
              class="textarea"
            ></textarea>
          </div>
          <!-- 风格按钮 -->
          <div class="style">
            <div
              class="style_button"
              :class="{ selected: selectedIndex === index }"
              v-for="(item, index) in style"
              :key="index"
              @click="chooseStyle(item.style, index)"
            >
              <img class="style_image" :src="item.styleImageURL" alt="" />
              <div class="style_name">{{ item.name }}</div>
            </div>
            <!-- <div class="style01">
              <div
                class="style_button02"
                :class="{ selected: selectedIndex === index }"
                v-for="(item, index) in style02"
                :key="index"
                @click="chooseStyle(item.style, index)"
              >
                <img class="style_image" :src="item.styleImageURL" alt="" />
                <div class="style_name">{{ item.name }}</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="left" @click="Previouspage()">←上一步</div>
        <div class="button" @click="changePicture()">
          生成图片
          <div class="frequency">次数（{{ frequency }}）</div>
        </div>
        <!-- <div class="nextstep" @click="nextStep()">下一步</div> -->
      </div>
    </div>
    <!-- 上传图片 -->
    <div v-show="false">
      <form ref="imgUploadForm">
        <input
          ref="uploadInput"
          type="file"
          accept="image/*"
          @change.prevent.stop="upload"
        />
      </form>
    </div>
    <!-- 提示 -->
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <!-- 加载 -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">{{ loadingInfo }}</p>
      </div>
    </div>
    <!-- 图片收藏 -->
    <b-modal
      ok-only
      ref="model_collectible"
      title="提示"
      @ok="collectibleOK"
      ok-title="确定"
    >
      <p class="my-4">是否收藏图片？</p>
    </b-modal>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl");
const config = require("@/common/config");
import axios from "axios";
export default {
  name: "AIimage_text_to_image",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      process: 1, //文生图 0； 图文生图 1； 图生图 2;
      frequency: "",
      text: {
        prompt: "请您先上传一张图片并描述图片要素，并生成图片。",
      },
      imageGeneration: false,
      imageUpload: false,
      imageUploadURL: "", //压缩后的图片url
      fileData: "", //压缩后的图片file
      image_text_to_image: {
        imageUrl: "", //输入草图的URL地址。输入草图需要与输出图像的分辨率比例保持一致，否则会导致图片拉伸变形，建议使用白色背景图。
        prompt: "", //提示词，用来描述生成图像中期望包含的元素和视觉特点。支持中英文，长度不超过75个字符，超过部分会自动截断。
        size: "768*768", //输出图像的分辨率。目前仅支持一种图像分辨率：768*768，且为默认值。
        num: 4, //生成图片的数量。取值范围为1~4张，默认为4。
        style: "", //输出图像的风格，目前支持以下风格取值：
        bankSerialNumber: "", //银行流水号
        phone: "", //手机号
      },
      imageList: [],
      taskId: "",
      errorMsg: "",
      loading: false,
      loadingInfo: "",
      ifDelSourcePic: 0, //是否删除原图的url 0：无原图URL 1:有原图URL
      backoff: null,
      imageQuantity: false,
      bankCode: "",
      selectParam: "",
      isCollected: false,
      selectedIndex: "", // 初始没有选中项
      style: [
        {
          name: "随机",
          styleImageURL: logUrl.logUrl.button01,
          style: "<auto>",
        },
        {
          name: "中国画",
          styleImageURL: logUrl.logUrl.button02,
          style: "<chinese painting>",
        },
        {
          name: "水墨画",
          styleImageURL: logUrl.logUrl.button03,
          style: "<chinese painting>",
        },
        {
          name: "卡通",
          styleImageURL: logUrl.logUrl.button04,
          style: "<3d cartoon>",
        },
        {
          name: "水彩",
          styleImageURL: logUrl.logUrl.button05,
          style: "<watercolor>",
        },
        {
          name: "二次元",
          styleImageURL: logUrl.logUrl.button06,
          style: "<anime>",
        },
        {
          name: "科技风",
          styleImageURL: logUrl.logUrl.button07,
          style: "<auto>",
        },
        {
          name: "插画",
          styleImageURL: logUrl.logUrl.button08,
          style: "<flat illustration>",
        },
      ],
      style02: [],
    };
  },
  methods: {
    Previouspage() {
      this.$router.push({
        name: "AISelectCardface_ccb",
      });
    },
    Maininterface() {
      this.$router.push({
        name: "HomePage",
      });
    },
    showCollectible() {
      this.$refs["model_collectible"].show();
    },
    collectibleOK() {
      this.collection();
    },
    // 收藏
    collection() {
      let params = {
        phone: this.image_text_to_image.phone,
        taskId: this.taskId,
      };
      console.log("collectible--->", params);
      axios.post(config.config_demo.collectible, params).then((res) => {
        console.log("collectible--->", res);
        if (res.data.code == 200) {
          this.isCollected = !this.isCollected;
        }
      });
    },
    // 选择风格
    chooseStyle(style, index) {
      // if (this.frequency <= 0) {
      //   this.errorMsg = "您的AI次数已用完，请您明天再来！";
      //   this.showErrorMsg();
      // } else {
      //   this.image_text_to_image.style = style;
      //   // this.applyNow();
      //   this.selectItem(index);
      // }
      this.image_text_to_image.style = style;
      // this.applyNow();
      this.selectItem(index);
    },
    selectItem(index) {
      // this.showLoading();
      this.selectedIndex = index;
      // this.main_button(this.buttonList[index]);
    },
    applyNow() {
      // if (this.frequency <= 0) {
      //   this.errorMsg = "您的AI次数已用完，请您明天再来！";
      //   this.showErrorMsg();
      // } else
      if (this.imageUploadURL == "") {
        this.errorMsg = "请上传图片";
        this.showErrorMsg();
      } else if (this.image_text_to_image.prompt == "") {
        this.errorMsg = "请填写描述信息";
        this.showErrorMsg();
      } else if (this.image_text_to_image.style == "") {
        this.errorMsg = "请选择风格";
        this.showErrorMsg();
      } else {
        this.uploadPic();
      }
    },
    uploadPic() {
      this.loadingInfo = "图片上传中...";
      this.showLoading();
      let that = this;
      let file = this.fileData;
      let formData = new FormData();
      formData.append("file", file);
      console.log("uploadPic--->", formData);
      axios.post(config.config_demo.uploadPic, formData).then((res) => {
        console.log("uploadPic--->", res);
        if (res.data.code == 200) {
          that.image_text_to_image.imageUrl = res.data.data.path;
          that.ifDelSourcePic = 1;
          that.AIimage_text_to_image();
        } else {
          this.hideLoading();
          this.errorMsg =
            "请上传合规图片（涉黄、涉暴、涉政等违规图片将无法审核通过）";
          this.showErrorMsg();
        }
      });
    },
    AIimage_text_to_image() {
      let that = this;
      let param = {
        imageUrl: this.image_text_to_image.imageUrl, //输入草图的URL地址。输入草图需要与输出图像的分辨率比例保持一致，否则会导致图片拉伸变形，建议使用白色背景图。
        prompt: this.image_text_to_image.prompt, //提示词，用来描述生成图像中期望包含的元素和视觉特点。支持中英文，长度不超过75个字符，超过部分会自动截断。
        size: this.image_text_to_image.size, //输出图像的分辨率。目前仅支持一种图像分辨率：768*768，且为默认值。
        num: this.image_text_to_image.num, //生成图片的数量。取值范围为1~4张，默认为4。
        style: this.image_text_to_image.style, //输出图像的风格，目前支持以下风格取值：
        bankSerialNumber: this.image_text_to_image.bankSerialNumber, //银行流水号
        phone: this.image_text_to_image.phone,
      };
      console.log("AIimage_text_to_image--->", param);
      axios
        .post(config.config_demo.AI_image_text_to_image, param)
        .then((res) => {
          console.log("AIimage_text_to_image--->", res);
          if (res.data.code == 200) {
            that.imageList = res.data.data.result;
            that.taskId = res.data.data.taskId;
            // localStorage.setItem("taskId", that.taskId);
            localStorage.setItem("taskId", that.taskId);
            that.imageGeneration = true;
            // that.getFrequency();
            that.decrResidualNums();
            this.hideLoading();
          } else {
            this.hideLoading();
            this.errorMsg =
              "请上传合规图片（涉黄、涉暴、涉政等违规图片将无法审核通过）";
            this.showErrorMsg();
          }
        })
        .catch((error) => {
          that.hideLoading();
          that.errorMsg = error;
          that.showErrorMsg();
        });
    },
    // 收藏夹
    favorites() {
      this.$router.replace({
        name: "AICollection_ccb",
        params: {
          process: this.process,
          taskId: this.taskId,
          // phone: this.image_text_to_image.phone,
          style: this.image_text_to_image.style,
          prompt: this.image_text_to_image.prompt,
        },
      });
    },
    // 重新上传
    changePicture() {
      if (this.frequency <= 0) {
        this.errorMsg = "您的AI次数已用完，请您明天再来！";
        this.showErrorMsg();
      } else if (this.ifDelSourcePic == 0) {
        // this.selectCardface();
        this.applyNow();
      } else if (this.ifDelSourcePic == 1) {
        this.delDFSPic();
        // this.selectCardface();
        this.applyNow();
      }
    },
    // 删除原图URL
    delDFSPic() {
      let params = {
        url: this.image_text_to_image.imageUrl,
        taskId: this.taskId,
      };
      console.log("delDFSPic--->", params);
      axios.post(config.config_demo.delSourcePic, params).then((res) => {
        console.log("delDFSPic--->", res);
        if (res.data.code == 200) {
          this.ifDelSourcePic = 0;
        } else {
          console.log("删除失败");
        }
      });
    },
    selectCardface() {
      this.resetUpload();
      this.$refs.uploadInput.click();
    },
    resetUpload: function () {
      var form = this.$refs.imgUploadForm;
      form.reset();
    },
    upload(event) {
      let that = this;
      console.log(event);
      let file = event.target.files[0];
      // 压缩上传的图片
      this.compressImage(file, 800, 600, 0.2)
        .then((compressedFile) => {
          // console.log("压缩后的文件:", compressedFile);
          // 上传或预览：compressedFile 可直接用于 FormData
          that.fileData = compressedFile;
          let url = null;
          if (window.createObjectURL != undefined) {
            // basic
            url = window.createObjectURL(compressedFile);
          } else if (window.webkitURL != undefined) {
            // webkit or chrome
            url = window.webkitURL.createObjectURL(compressedFile);
          } else if (window.URL != undefined) {
            // mozilla(firefox)
            url = window.URL.createObjectURL(compressedFile);
          }
          console.log("imageUploadURL--->", url);
          that.imageUploadURL = url;
          that.imageUpload = true;
          that.imageGeneration = false;
        })
        .catch((err) => console.error("压缩失败:", err));
    },
    // 压缩图片
    compressImage(file, maxWidth, maxHeight, quality = 0.7) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = () => {
            // 1. 计算等比例缩放后的尺寸
            let { width: originWidth, height: originHeight } = img;
            let targetWidth = originWidth;
            let targetHeight = originHeight;

            // 如果图片尺寸超过最大限制，则按比例缩小
            if (originWidth > maxWidth || originHeight > maxHeight) {
              const ratio = Math.min(
                maxWidth / originWidth,
                maxHeight / originHeight
              );
              targetWidth = originWidth * ratio;
              targetHeight = originHeight * ratio;
            }

            // 2. 创建 Canvas 并绘制缩放后的图片
            const canvas = document.createElement("canvas");
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

            // 3. 转换为 Blob（可设置压缩质量）
            canvas.toBlob(
              (blob) => {
                // 生成压缩后的 File 对象（保留原始文件名和类型）
                const compressedFile = new File([blob], file.name, {
                  type: "image/jpeg", // 强制转为 JPEG 格式，或使用 file.type
                  lastModified: Date.now(),
                });
                resolve(compressedFile);
              },
              "image/jpeg", // 可改为 'image/png' 等
              quality // 质量参数（0-1）
            );
          };

          img.onerror = (err) => reject(err);
        };

        reader.onerror = (err) => reject(err);
      });
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    handleOk: function (bvModalEvt) {},
    nextStep(index) {
      // this.chooseStyle(index);
      this.loadingInfo = "编辑图片...";
      this.showLoading();
      this.pic2Base64(index);
    },
    // url转换成base64
    pic2Base64(index) {
      let param = {
        url: this.imageList[index].imagePath,
      };
      console.log("pic2Base64--->", param);
      axios
        .post(config.config_demo.pic2Base64, param)
        .then((res) => {
          console.log("pic2Base64--->", res);
          this.imagePath = res.data.data.base64;
          this.toEditCardface();
        })
        .catch();
    },
    toEditCardface() {
      this.hideLoading();

      this.$router.push({
        name: "AIEditCardface_ccb",
        params: {
          imagePath: this.imagePath,
          process: this.process,
          taskId: this.taskId,
          style: this.image_text_to_image.style,
          phone: this.image_text_to_image.phone,
        },
      });
    },
    // 查询
    getRecords() {
      let that = this;
      let params = {
        phone: this.image_text_to_image.phone,
        taskId: localStorage.getItem("taskId"),
        isSave: "",
      };
      console.log("getRecords--->", params);
      axios.post(config.config_demo.getRecords, params).then((res) => {
        console.log("getRecords--->", res);
        if (res.data.code == 200) {
          that.imageList = res.data.data;
          that.imageGeneration = true;
        } else {
          console.log("getRecords错误");
        }
      });
    },
    // 查询次数
    getFrequency() {
      let phone = localStorage.getItem("phone_ccb");
      axios
        .get(config.config_demo.initResidualNums + `/${phone}`)
        .then((res) => {
          console.log("initResidualNums--->", res);
          if (res.data.code == 200) {
            this.frequency = res.data.data.num;
          } else {
            console.log("getRecords错误");
          }
        });
    },
    // 减少次数
    decrResidualNums() {
      let phone = localStorage.getItem("phone_ccb");
      axios
        .get(config.config_demo.decrResidualNums + `/${phone}`)
        .then((res) => {
          console.log("decrResidualNums--->", res);
          if (res.data.code == 200) {
            this.frequency = res.data.data.num;
          } else {
            console.log("getRecords错误");
          }
        });
    },
  },
  created() {
    this.getFrequency();
  },
  mounted() {
    // phone
    this.image_text_to_image.phone = localStorage.getItem("phone_ccb");
    this.backoff = this.$route.params.backoff;
    if (this.backoff == 0) {
      // 正常流程
      // this.phone = this.$route.params.phone;
    } else if (this.backoff == 1) {
      // 回退流程
      this.taskId = this.$route.params.taskId;
      this.image_text_to_image.phone = localStorage.getItem("phone_ccb");
      if (this.taskId == "") {
        // 正常流程
      } else {
        this.getRecords();
      }
    }
    this.image_text_to_image.bankSerialNumber = localStorage.getItem(
      "bankSerialNumber_ccb"
    );
    console.log(
      "bankSerialNumber:" + this.image_text_to_image.bankSerialNumber
    );
    // this.radio = this.$route.query.radio;   //是否邮寄参数
    // console.log("radio:" + this.radio);
    this.bankCode = localStorage.getItem("bankCode");
    console.log("bankCode:" + this.bankCode);
    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
  },
  beforeDestroy() {
    this.imageGeneration = false;
    if (this.ifDelSourcePic == 0) {
    } else {
      this.delDFSPic();
    }
  },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
.image_part {
  width: 100%;
  height: 25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.image_collection {
  width: 100%;
  height: 2rem;
  background-color: antiquewhite;
  border-radius: 0.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.6rem;
}
.collection {
  font-size: 0.9rem;
  font-weight: 700;
}
.favorites {
  font-size: 0.9rem;
  font-weight: 700;
}

.image_background {
  width: 100%;
  height: 100%;
  background: url("../../../../static/demoImage/背景01.png") no-repeat center /
    cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
}
.image_background_upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center; /* 垂直居中 */
}
.image_upload {
  width: 40%;
}
.upload {
  background-color: whitesmoke;
  border-radius: 1rem;
  width: 100%;
  height: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center; /* 垂直居中 */
}
.upload_name {
  font-size: 0.8rem;
  font-weight: 600;
}
.upload_button {
  width: 3rem;
  height: 3rem;
  border: 1px solid black;
  border-radius: 0.4rem;
}
.image_display {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.image_display01 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.image_display_prompt {
  font-weight: 700;
}
.image_ontology {
  width: 8rem;
  border-radius: 0.4rem;
}
.textarea {
  margin-top: 1rem;
  width: 100%;
  height: 3rem;
  border-radius: 1rem;
  text-align: center;
}
.style {
  width: 100%;
  height: 7rem;
  display: flex;
  flex-wrap: wrap;
}
.style01 {
  width: 100%;
  height: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}
.style_button {
  width: 25%;
  height: 3rem;
  position: relative;
  /* 确保元素可以显示边框 */
  box-sizing: border-box;
  cursor: pointer;
  border: 2px solid transparent; /* 预置透明边框避免布局抖动 */
  transition: border-color 0.2s ease; /* 可选：过渡效果 */
}
.style_button.selected {
  border: 2px solid #093695;
  border-radius: 0.6rem;
  outline: none;
}
.style_button02 {
  width: 22%;
  height: 3rem;
  position: relative;
  /* 确保元素可以显示边框 */
  box-sizing: border-box;
  cursor: pointer;
  border: 2px solid transparent; /* 预置透明边框避免布局抖动 */
  transition: border-color 0.2s ease; /* 可选：过渡效果 */
}
.style_button02.selected {
  border: 2px solid #093695;
  border-radius: 0.6rem;
  outline: none;
}
.style_name {
  /* 绝对定位居中核心代码 */
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translate(-50%, -50%);
  font-size: 0.6rem;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_image {
  display: block; /* 消除图片底部间隙 */
  width: 100%;
  height: 100%;
}
.footer {
  /* background-color: blue;
  height: 3rem; */
  padding-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.button {
  color: white;
  /* background-color: #3861d5; */
  background: linear-gradient(to right, #093695, #0d1632);
  display: flex; /* 启用 Flex 布局 */
  align-items: center; /* 垂直居中 */
  justify-content: center;
  font-size: 0.8rem;
  border-radius: 1.2rem;
  width: 50%;
  height: 2.6rem;
}
.nextstep {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  border-radius: 1.2rem;
  width: 45%;
  height: 2.4rem;
  border: 1px solid black;
}
.frequency {
  font-size: 0.6rem;
  margin-left: 0.3rem;
}
.left {
  width: 40%;
  height: 2.6rem;
  border: 1px solid #023bb6;
  border-radius: 1.3rem;
  color: #023bb6;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  padding-top: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CCB_demo/AIGC/AIimage_text_to_image.vue